import React from "react";
import { Stepper } from '@activehub/common-components-spa-resource'
import "./AccessCodeRegisterActiveHub.scss";
import AccessCodeActiveHub from "./AccessCodeActiveHub";
import ActivationSuccessTemplate from "./ActivationSuccessTemplate";
import { useAction } from './useAction';

const steps = [
  'Access code',
  'Activation complete'
]

export const AccessCodeFormActiveHub = (props) => {
  const { step, handleNextStep, handleBackStep } = useAction();
  const renderstep = (step) => {
    switch (step) {
      case 1: return <AccessCodeActiveHub onNextStep={handleNextStep} onBackStep={handleBackStep} />;
      case 2: return <ActivationSuccessTemplate />;
      default: return <div>404 - Not Found</div>
    }
  }

  return (
    <div className="ActiveHubStepper mobile-tab-responsive" >
      <Stepper steps={steps} active={step === 2 ? 3 : step} themeClass={"pearsonRoyalBlueV1"} svgPath={`${process.env.PUBLIC_URL}/images/login-stepper-success.svg`}/>
      {renderstep(step)}
    </div>
  )
};


